import { forwardRef } from 'react';

import { MilestonesEventsWidget } from '@crehana/compass.dashlets';

import { useGetMilestonesEvents } from '../hooks/use-get-milestones-events';

const MilestonesEventsWidgetComponent = forwardRef<HTMLDivElement>(() => {
  const {
    loading: loadingMilestonesEvents,
    dataMilestonesEvents,
    error: errorMilestonesEvents,
    refetch: retryMilestonesEvents,
  } = useGetMilestonesEvents();

  return (
    <MilestonesEventsWidget
      todayEvents={dataMilestonesEvents?.todayEvents || []}
      nextEvents={dataMilestonesEvents?.nextEvents || []}
      loading={loadingMilestonesEvents}
      error={!!errorMilestonesEvents}
      refetch={retryMilestonesEvents}
    />
  );
});

MilestonesEventsWidgetComponent.displayName = 'MilestonesEventsWidgetComponent';

export { MilestonesEventsWidgetComponent };
